module.exports = "./img/47231478e3baefb24392327ab4bbb4fd.jpg";